import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { PaySoftBankList } from 'src/app/enum/PaySoftBankList';
import { DebitFormDataService } from 'src/app/services/debit-form-data.service';
import { GraylogNotificationConfigurationService } from 'src/app/services/graylog-notification-configuration.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ProfileDetailService } from 'src/app/services/profile-detail.service';
import { UploaddataService } from 'src/app/services/uploaddata.service';
import { UserdataService } from 'src/app/services/userdata.service';
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-amend-banking-details',
  templateUrl: './amend-banking-details.component.html',
  styleUrls: ['./amend-banking-details.component.scss']
})
export class AmendBankingDetailsComponent implements OnInit {
  form: FormGroup
  addBankingDetails: boolean = false;

  showdata = false;
  bankList: any;
  typeofaccount = [{ key: 1, value: 'Savings' }, { key: 2, value: 'Current' }, { key: 3, value: 'Transmission' },]
  debitorder = [{ key: 0, value: '1st' }, { key: 1, value: '15th' }, { key: 2, value: '25th' },]
  debit: any;
  filteredList: any;
  data: any = [
    { id: 1, documenttype: 'Proof of Residence', date: '', filename: '', fileObject: null, action: false, type: '2' },
  ];
  dataSource: any = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "DocumentType",
    "Date",
    "FileName",
    "Action",
  ];
  fileName: string;
  isFileSelected: boolean;
  file: any;
  filedate: any;
  FileExtention: string;
  bankaccountmode;
  PaySoftBankList: any = Object.values(PaySoftBankList);
  userId: any;
  applicationId: any;
  applicationDetails: any;
  addPostData: any;
  ip: any;

  constructor(
    private route: ActivatedRoute,
    private navigation: NavigationService,
    private formBuilder: FormBuilder,
    private debitformdataservice: DebitFormDataService,
    private userdataservice: UserdataService,
    private profileDetailService: ProfileDetailService,
    private uploaddataservice: UploaddataService,
    private graylogNotificationConfigurationService: GraylogNotificationConfigurationService,
    private applicationDataService: ApplicationDataService,
    private debitform: DebitFormDataService,
    private UtilityService: UtilityService
  ) {
    // ✅ Check if URL contains /applicationid
    this.applicationId = this.route.snapshot.paramMap.get('applicationId');
    if (this.applicationId) {
      this.addBankingDetails = true;   // Add mode
      console.log('Add mode with ID:', this.applicationId);
      this.UtilityService.getIpAddress().subscribe((result) => {
        this.ip = result;
      })
      this.getDetailsForBankAdd();
    }
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      searchQuery: [null, Validators.required],
      bank: [],
      code: [],
      accountNumber: [],
      accountType: [],
      isEFT: [],
      dateOfDebitOrderRun: [],
    })
    this.form.get('code')?.disable();

    this.getdata()

  }


  getDetailsForBankAdd() {
    this.applicationDataService.getApplicationDetails(this.applicationId).subscribe((result) => {
      if (result) {
        console.log('applicationDetails', result);
        debugger
        this.addPostData = {};
        this.addPostData.accountHolderName = result.customerAddressMapping?.customer?.firstName + ' ' + result.customerAddressMapping?.customer?.lastName;
        this.addPostData.totalAmountExcludingVAT = result.totalAmountExcludingVAT;
        this.addPostData.onceOffFeeExcludingVAT = 0;
        this.addPostData.vat = result.vat;
        this.addPostData.beneficiaryName = result.beneficiaryName;
        this.addPostData.abbreviatedName = "AFRIHOST HC";
        this.addPostData.beneficiaryAddress = result.beneficiaryAddress;
        this.addPostData.applicationId = this.applicationId;
        this.addPostData.agreedOnDate = new Date();
        this.addPostData.ipAddress = this.ip;
        this.addPostData.addDebitFormFromAdmin = true;
        this.addPostData.referenceNumber = result.referenceNumber;
      }

    })


  }
  getdata() {
    this.debitformdataservice.getBankList().subscribe((result) => {
      if (result) {
        this.bankList = result;
        this.filteredList = result;
      }

    })
    this.graylogNotificationConfigurationService.GraylogNotificationConfiguration().subscribe((result) => {
      this.bankaccountmode = result.find(item => item.key == 'BankVerificationStatus').value;
    })

  }
  getbranchcode() {
    let value = this.form.value.bank;
    console.log('bank', value)
    let code = this.bankList.find(item => item.name == value)
    console.log('bankdetails', code)
    this.form.controls['code'].setValue(code.code)
  }

  restrictSpace(event: KeyboardEvent): void {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }

  gotochangebankdetails() {
    if (this.addBankingDetails) {
      this.navigation.gotomanagefiber();
    }
    else {
      this.navigation.gotochangebankdetails();
    }
  }
  search() {
    if (this.form.valid) {
      this.userdataservice.getBankingDetailsBySearch(this.form.value.searchQuery).subscribe((result) => {
        if (result) {
          this.showdata = true
          this.debit = result
          this.form.patchValue({ ...result })
        }
        else {
          Swal.fire('Error!', 'Please Enter a Valid Details', 'error')
        }
      })
    }

  }

  fileupload() {
    if (this.data[0].action == false) {
      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.style.display = 'none';
      document.body.appendChild(inputElement);
      inputElement.click();
      inputElement.addEventListener('change', async (event: any) => {
        const files: FileList = (event.target as HTMLInputElement).files;
        if (!files || files.length === 0) {
          Swal.fire('Warning', 'Please upload a file', 'warning');
          return;
        }
        if (files.length > 1) {
          Swal.fire('Warning', 'Please upload only one file', 'warning');
          return;
        }
        this.file = files[0];
        this.fileName = this.file.name;
        console.log('file', this.fileName);
        this.filedate = this.formatDate(new Date());

        // Check for existing file names
        const fileExists = this.data.some(item => item.filename === this.fileName && item.action === true);
        if (fileExists) {
          Swal.fire('Warning', 'This file has already been uploaded. Please upload a different file.', 'warning');
          this.fileName = '';
          this.isFileSelected = false;
          document.body.removeChild(inputElement);
          return;
        }

        const fileExtension = this.fileName.split('.').pop().toLowerCase();
        const validExtensions = ['png', 'jpeg', 'jpg', 'pdf', 'doc', 'docx'];
        const validMimeTypes = [
          'image/png',
          'image/jpeg',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ];
        const isValidExtension = validExtensions.includes(fileExtension);
        const isValidMimeType = validMimeTypes.includes(this.file.type);
        if (!isValidExtension || !isValidMimeType) {
          Swal.fire(
            'Warning',
            `Please upload a correct file format (png, jpeg, jpg, pdf, doc, docx)`,
            'warning'
          );
          this.fileName = '';
          this.isFileSelected = false;
          document.body.removeChild(inputElement);
          return;
        }

        this.FileExtention = fileExtension;
        this.isFileSelected = true;
        console.log(this.file);
        document.body.removeChild(inputElement);
        this.data[0].filename = this.fileName;
        this.data[0].date = this.filedate;
        this.data[0].action = true;
        this.data[0].fileObject = this.file;

        this.dataSource = new MatTableDataSource(this.data);
        console.log(this.data);
      });
    } else {
      this.fileName = '';
      this.isFileSelected = false;
      this.data[0].filename = '';
      this.data[0].date = '';
      this.data[0].action = false;
      this.data[0].fileObject = null;
      this.dataSource = new MatTableDataSource(this.data);
    }
  }

  formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleString('en-US', options).replace(',', '');
  }

  async save() {
    // if (this.debit.dateOfDebitOrderRun != 1 && this.form.value.dateOfDebitOrderRun == 1) {
    //   Swal.fire('Warning!', 'Debit date 15th not allowed, Please select Diffrent debit date', 'warning')
    // }
    if (this.bankaccountmode == 1) {
      var result: any = await this.bankAccountVerification();
      if (result) {
        this.saveDebitForm()
      }
    }
    else {
      this.saveDebitForm()
    }
  }

  bankAccountVerification(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const value = this.form.getRawValue();
      const isPaySoftBank = this.PaySoftBankList.find(item => item === value.code);
      if (isPaySoftBank) {
        const postData: any = {
          name: this.debit.accountHolderName,
          accountNumber: value.accountNumber,
          branchCode: value.code
        };
        this.profileDetailService.getBankAccountVerification(postData).subscribe(
          async (result) => {
            if (result.isAccountExists && result.isAccountOpen && result.isAcceptsDr) {
              await Swal.fire({
                title: 'Success!!',
                text: 'Banking details had been verified successfully.',
                icon: 'success',
                confirmButtonText: 'OK'
              }).then(isConfirm => {
                if (isConfirm) {
                  resolve(true);
                }
              });
              resolve(true);
            }
            else if (result.isNoResponse) {
              resolve(true);
            }
            else if (result.isError) {
              let error = "Oops! There has been an error reaching your bank to verify the details, please try again. Should the problem persist, please wait 5 minutes before retrying.";
              if (result.errorMessage) {
                error = "The bank account details provided could not be verified, please review the details again and correct your information.Please click on Proceed once you have made the necessary changes.";
              }
              Swal.fire({
                text: error,
                position: 'center',
                icon: 'warning'
              })
              resolve(false);
            }

            else {
              let failedMessage = "";

              if (!result.isAccountExists) {
                failedMessage = "The bank account number does not exist. Please check and try again.";
              }
              else if (!result.isAccountOpen) {
                failedMessage = "The bank account is not open or active. Please verify with your bank.";
              }
              else if (!result.isAcceptsDr) {
                failedMessage = "Debit transactions are blocked for this bank account.";
              }
              else {
                failedMessage = "Unable to verify bank details. Please review and try again.";
              }

              Swal.fire({
                text: failedMessage,
                position: 'center',
                icon: 'warning'
              });

              resolve(false);
            }
          },
          (error) => {
            Swal.fire(
              'Error!',
              'Oops! There has been an error reaching your bank to verify the details, </p> <p> please try again. Should the problem persist, please wait 5 minutes before retrying.',
              'error'
            );
            reject(false);
          }
        );
      } else {
        resolve(true);
      }
    });
  }

  saveDebitForm() {
    let value = this.form.getRawValue()
    this.userdataservice.getUserIdBySearch(value.searchQuery).subscribe((result) => {
      if (result) {
        console.log('debit before', this.debit)
        const { searchQuery, ...rest } = value;
        // this.debit = { ...this.debit, ...rest };
        var postData: any = {}
        if (this.addBankingDetails) {
          this.debit = { ...this.debit, ...rest, ...this.addPostData };
          // postData = this.addPostData;
        }
        else {
          this.debit = { ...this.debit, ...rest };
        }
        postData = this.debit;
        this.userId = result.id;
        debugger
        postData.customerUserId = result.id;
        console.log('postdata', postData)
        this.debitformdataservice.savedebitFormFromAdmin(postData).subscribe((result) => {
          console.log('save debit form result', result);
          if (result) {
            this.debitformdataservice.updateDebitFormSendNotificationEmail(result).subscribe((res) => {
              console.log('updateDebitFormSendNotificationEmail result', res);
              if (res) {
                if (this.data[0].action)
                  this.uploadfile()
                else
                  this.debitformdataservice.saveBankingDetailsProof(this.userId).subscribe((result) => {
                    if (result) {
                      if (this.addBankingDetails) {
                        this.applicationDataService.updateApplicationStatusAndAcceptShopOrder(this.applicationId).subscribe((result) => {
                          if (result) {
                            Swal.fire('Success!!', 'Your Banking details has been Added Sucessfully', 'success')
                            this.navigation.gotomanagefiber();
                          }
                          else {
                            Swal.fire('Error!!', 'Sorry try again later', 'error')
                          }
                        });
                      }
                      else {
                        Swal.fire('Success!!', 'Your Banking details has been Updated Sucessfully', 'success')
                        this.clearFilter()
                      }
                    }
                    else
                      Swal.fire('Error!!', 'Sorry try again later', 'error')
                  })
              }
            })
          }
        })
      }
    })
  }

  uploadfile() {
    let formdata: FormData = new FormData
    formdata.append('file', this.data[0].fileObject)
    formdata.append('userId', this.userId)
    this.uploaddataservice.getBankingDetailsUpdateFileUploaderInstance(formdata).subscribe((result) => {
      if (result)
        Swal.fire('Success!!', 'Your Banking details has been Updated Sucessfully', 'success')
      this.clearFilter()
    })
  }

  clearFilter() {
    this.form.reset();
    this.showdata = false
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
}
